module.exports = "/_next/static/images/JECRCCLOUDSUMMIT2-618c3cd08057a28a883d35fb2ae6b5a6.jpg";